import ReactGA from 'react-ga4'
import { analyticsId } from './index'

const options = {}

const trackPage = page => {
  if (analyticsId) {
    // Treat all results pages as one for now
    if (page.endsWith('/results')) {
      page = '/results'
    }
    ReactGA.set({
      page,
      ...options
    })
    ReactGA.send({ hitType: 'pageview', page: page })
  }
}

let currentPage = ''

export const googleAnalytics = store => next => action => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    const nextPage = `${action.payload.pathname}${action.payload.search}`

    if (currentPage !== nextPage) {
      currentPage = nextPage
      trackPage(nextPage)
    }
  }

  return next(action)
}



// WEBPACK FOOTER //
// ./src/analytics/middleware.ts